export default __webpack_public_path__ + "fa6ec8e9b506a028350736860db4a634.png";